export function hasSignedMsa(organization: any): boolean {
    const document = organization?.msaDocument;
    return Boolean(document?.signedAt && (document.storagePath || document.signedPath));
}
